import React from 'react';
import { Users, CheckCircle, Calendar, Clock } from 'lucide-react';
export const LongTermCollaborationSection = () => {
  return <section className="w-full py-24 bg-gray-50" data-id="element-43">
      <div className="container mx-auto px-6" data-id="element-44">
        <div className="flex flex-col lg:flex-row gap-16" data-id="element-45">
          {/* Left column - main content */}
          <div className="lg:w-1/2" data-id="element-46">
            
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8" data-id="element-47">
              Long-term Collaboration as Product Lead
            </h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed" data-id="element-48">
              Embed experienced product leadership directly within your team to
              drive consistent results and build sustainable product practices.
            </p>
            <div className="mb-10" data-id="element-49">
              <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-50">
                Why bring me onto your team?
              </h3>
              <ul className="space-y-4" data-id="element-51">
                {['Consistent strategic guidance and leadership without the overhead of a full-time executive', 'Accelerated product development through proven methodologies and frameworks', 'Team capability building and knowledge transfer to strengthen your internal resources', 'Objective perspective from someone who understands your industry but isn', 'Flexible engagement model that scales with your needs and timeline'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-52">
                    <CheckCircle className="w-6 h-6 text-blue-700 flex-shrink-0 mt-0.5" data-id="element-53" />
                    <span className="text-gray-700" data-id="element-54">{item}</span>
                  </li>)}
              </ul>
            </div>
            <a href="#contact" className="inline-block px-8 py-4 bg-gray-900 text-white font-medium rounded-none hover:bg-gray-800 transition-colors text-sm uppercase tracking-wider" data-id="element-55">
              Discuss Your Team Needs
            </a>
          </div>
          {/* Right column - engagement options */}
          <div className="lg:w-1/2" data-id="element-56">
            <div className="bg-white p-10 border border-gray-200 shadow-sm" data-id="element-57">
              <h3 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-58">
                Engagement Options
              </h3>
              <div className="space-y-10" data-id="element-59">
                {/* Advisory option */}
                <div className="border-b border-gray-100 pb-10" data-id="element-60">
                  <div className="flex items-center gap-3 mb-4" data-id="element-61">
                    <Calendar className="w-6 h-6 text-blue-700" data-id="element-62" />
                    <h4 className="text-xl font-bold text-gray-900" data-id="element-63">
                      Strategic Advisory
                    </h4>
                  </div>
                  <p className="text-gray-700 mb-4" data-id="element-64">
                    Part-time engagement (1-2 days per week) focused on
                    strategic guidance, team coaching, and specific product
                    challenges.
                  </p>
                  <div className="bg-gray-50 p-6 mt-6" data-id="element-65">
                    <h5 className="font-medium text-gray-900 mb-3" data-id="element-66">
                      Ideal for teams that:
                    </h5>
                    <ul className="space-y-2" data-id="element-67">
                      {['Have existing product resources but need strategic guidance', 'Face specific product challenges or pivotal decisions', 'Want to improve processes and methodologies', 'Need external perspective on product strategy'].map((item, index) => <li key={index} className="flex items-start gap-2" data-id="element-68">
                          <div className="w-1 h-1 bg-gray-500 rounded-full mt-2.5 flex-shrink-0" data-id="element-69"></div>
                          <span className="text-gray-700 text-sm" data-id="element-70">{item}</span>
                        </li>)}
                    </ul>
                  </div>
                </div>
                {/* Embedded option */}
                <div data-id="element-71">
                  <div className="flex items-center gap-3 mb-4" data-id="element-72">
                    <Clock className="w-6 h-6 text-blue-700" data-id="element-73" />
                    <h4 className="text-xl font-bold text-gray-900" data-id="element-74">
                      Embedded Leadership
                    </h4>
                  </div>
                  <p className="text-gray-700 mb-4" data-id="element-75">
                    Comprehensive engagement (3-5 days per week) with hands-on
                    product leadership, team management, and organizational
                    alignment.
                  </p>
                  <div className="bg-gray-50 p-6 mt-6" data-id="element-76">
                    <h5 className="font-medium text-gray-900 mb-3" data-id="element-77">
                      Ideal for teams that:
                    </h5>
                    <ul className="space-y-2" data-id="element-78">
                      {['Need interim product leadership during transitions', 'Are scaling rapidly and need experienced guidance', 'Require comprehensive product process implementation', 'Want to build a product-led organization from the ground up'].map((item, index) => <li key={index} className="flex items-start gap-2" data-id="element-79">
                          <div className="w-1 h-1 bg-gray-500 rounded-full mt-2.5 flex-shrink-0" data-id="element-80"></div>
                          <span className="text-gray-700 text-sm" data-id="element-81">{item}</span>
                        </li>)}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};